<template>

  <div class="padded">
    <h1>Payment History</h1>

    <table class="el-table" style="padding-top: 1em;">
      <thead>
        <tr>
          <th>#</th>
          <th>Date</th>
          <th>Ref</th>
          <th align="right">Amount</th>
          <th v-if="showTax()" align="right">{{taxLabel}}</th>
          <th align="right">TOTAL</th>
          <th></th>
        </tr>
      </thead>
      <tfoot>
      </tfoot>
      <tbody>
        <tr v-for="(item, index) in items" :key="index">
          <th>{{index+1}}</th>
          <td>{{formatDate(item.date)}}</td>
          <td align="center">{{formatInteger(item.quantity)}}</td>
          <td>{{item.ref}}</td>
          <td align="right">{{formatNumber(item.amount)}}</td>
          <td v-if="showTax()" align="right">{{formatNumber(item.tax)}}</td>
          <td align="right">{{formatNumber(item.total)}}</td>
          <td align="center"><el-button size="small" type="danger" icon="fa fa-times-circle" /></td>
        </tr>
      </tbody>
    </table>

  </div>

</template>


<script>

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'

import PostMixins from '@/mixins/PostMixins'

import {settings} from '@/components/Data'

export default {

  mixins: [DateMixins, NumberMixins, PostMixins],

  props: {
    rowData: {
      type: Object,
      required: true
    },
    siteId: {
      type: Number
    },
    clientSiteId: {
      type: String
    },
    siteName: {
      type: String
    },
    editMode: {
      type: Boolean,
      default: false
    },
    tableRef: {
      type: String,
      default: 'insurance-statement-table'
    },
    adding: {
      type: Boolean,
      default: false
    },
    hidePanel: {
      type: Boolean,
      default: false
    }
  },

  methods: {
    resetData () {
      this.form.site_id = this.localSiteId
      this.form.organisation_id = null
    },

    success (response) {
      this.resetData()
      this.$events.emit(this.tableRef + '-refresh-table')
    },

    onCancel () {
      this.disabled = true
    },

    onEdit () {
      this.disabled = false
    },

    onAdd () {
      this.disabled = false
      this.onSave()
    },

    onSave () {
      if (!this.form.site_id && this.localSiteId) {
        this.form.site_id = this.localSiteId
      }
/*
      this.form.issued = this.formatDateSql(this.form.issued)
      this.form.expiry = this.formatDateSql(this.form.expiry)

      this.saveForm(this, '/permits', this.form.id, this.form, this.form.summary, this.success)
      this.disabled = true
      //      this.resetData()
  */
    },

    onClose () {
      this.resetData()
      this.disabled = true
    }
  },

  data () {
    return {
      form: this.rowData,  // @BUG needs actual meta data from table.
      site: {
        siteId: this.siteId,
        siteName: this.siteName
      },
      currency: settings.currency,
      loading: false,
      sharers: [],
      items: [],
      localSite: this.rowData,
      disabled: true,
      taxLabel: settings.taxName,
      localSiteId: (this.site_id ? this.site_id : (this.rowData.site_id && this.rowData.coverage ? this.rowData.id : this.rowData.site_id))
    }
  },

  mounted () {
    if (this.adding) {
      this.disabled = false
      delete this.form.id
    }

    if (this.rowData && this.rowData.sharers) {
      this.sharers = this.rowData.sharers
    }

    this.form.site_id = (this.adding ? this.localSiteId : this.form.site_id)
    this.localSiteId = (this.siteId != null ? this.siteId : this.form.site_id)

    if (this.form.site_id && !this.localSiteId) {
      this.localSiteId = this.form.site_id
    }

//    console.log('LicenseePayment- form.site_id', this.form.site_id, 'localSiteId', this.localSiteId, 'siteId', this.siteId, 'rowData', this.rowData)
  }
}

</script>
